function goToCheckout(){
  if(document.URL == "https://the-rangers-story.co.uk/"){
  	// LIVE
  	jQuery("#product_form_7600219488485 .shopify-payment-button__more-options").click();
  } else{
  	// STG
  	jQuery("#product_form_7466310336669 .shopify-payment-button__more-options").click();
  }
}

function updateProductData(){
  var variantID;
  var variantWeight;
  var variantWeightKg;
  var variantPrice;
  var selectedVariant = jQuery('#SingleOptionSelector-0 option:selected');
  var selectedVariantText = selectedVariant.text();
  var priceText = jQuery(".product__price .price-item");
  var weightText = jQuery(".product__weight");
  var productSelect = jQuery("#ProductSelect-product-template");
  var productSeletctHomepage = jQuery("#ProductSelect-product-template-homepage");
  
  $.get("/products.json", function(data, status){

    for (let i in data.products[0].variants) {
      if(data.products[0].variants[i].title == selectedVariantText){
        variantID = data.products[0].variants[i].id;
        variantWeight = data.products[0].variants[i].grams;
        variantPrice = data.products[0].variants[i].price;
        //console.log(variantWeight);
        //console.log(variantPrice);

        productSelect.val(variantID).change();
        productSeletctHomepage.val(variantID).change();

        priceText.text("£" + variantPrice + " GBP");
        variantWeightKg = variantWeight / 1000;
        weightText.text("Weight: " + variantWeightKg + "kg");
      }
    }
  });
}

jQuery(document).ready(function() {

  // BUY NOW HEADER
  jQuery("header .header__buy-now button").click(function() {
    //jQuery("#product_form_7600219488485 .shopify-payment-button__button._2ogcW-Q9I-rgsSkNbRiJzA._2EiMjnumZ6FVtlC7RViKtj._2-dUletcCZ2ZL1aaH0GXxT").click();
    //jQuery("#product_form_7600219488485 .shopify-payment-button__button .shopify-cleanslate div").click();
  	goToCheckout();
  });

  // BUY NOW AT BOTTOM OF PAGE
  jQuery("#shopify-section-164424411102a41729 button").click(function() {
    //jQuery("#product_form_7600219488485 .shopify-payment-button__button._2ogcW-Q9I-rgsSkNbRiJzA._2EiMjnumZ6FVtlC7RViKtj._2-dUletcCZ2ZL1aaH0GXxT").click();
    //jQuery("#product_form_7600219488485 .shopify-payment-button__button .shopify-cleanslate div").click();
  	goToCheckout();
  });
  
  // MAIN BUY NOW BUTTON
  jQuery(".buy-now_button .custom button").click(function() {
  	goToCheckout();
  });
  
  // UPDATE VARIANT PRODUCT DATA
  updateProductData();
  jQuery('#SingleOptionSelector-0').change(function(){
    updateProductData();
  });
});